import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';

import { errorHelper } from 'src/utils';
import http from 'src/api/endpoints';
import { ErrorMessageFromApi } from 'src/constants';
import { PARENT_URL } from 'src/config/parentURL';

interface InitialState {
  loading: boolean;
  data: [];
  error: string | undefined | null;
  currentCardIndexes: any[];
  addedStaffRecord: any[];
  removedStaffRecords: any[];
}

const initialState: InitialState = {
  loading: false,
  data: [],
  error: null,
  currentCardIndexes: [],
  addedStaffRecord: [],
  removedStaffRecords: [],
};

export const getAllProjects = createAsyncThunk('projects', async (_, thunk) => {
  try {
    const response = await http.getAllProjects(PARENT_URL.TEAM_BUILDER_BASE);
    if (response.message === 'The request is completed successfully') {
      return response.data.projectList;
    }
    return thunk.rejectWithValue(errorHelper(ErrorMessageFromApi));
  } catch (error) {
    return thunk.rejectWithValue(errorHelper(error));
  }
});

export const allProjectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllProjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllProjects.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.error.message;
        toast.error(ErrorMessageFromApi, { duration: 2000 });
      });
  },
});

